<div class="wrapper-foodspot">
	<div class="left">
		<h3>{{ 'foodspot_dialog.title' | translate }}</h3>
		<p>
			{{ 'foodspot_dialog.subtitle' | translate }}
		</p>
		<!-- <a href>Fint out more</a> -->
	</div>
	<div class="right">
		<div class="header-section">
			<h3>{{ 'preorder_type.foodspot' | translate }}</h3>
			<ion-icon (click)="close()" src="../../../assets/topgolf/cross.svg"></ion-icon>
		</div>
		<div class="input-section">
			<h3>{{ 'preorder_type.foodspot' | translate }}</h3>

			<p>{{ 'foodspot_dialog.about_description' | translate }}</p>
			<div class="input-block">
				<ion-input
					[class.error]="inputControl.hasError('notExist')"
					[formControl]="inputControl"
					class="no-underline"
					[placeholder]="'enter_foodspot.placeholder' | translate"
					type="text"
				></ion-input>

				<ion-button (click)="validate()" [disabled]="!this.inputControl.value || loading"
					>{{ 'foodspot_dialog.submit' | translate }}
				</ion-button>
			</div>
			@if (inputControl.hasError('notExist')) {
				<div class="error-message">
					<span>{{ 'foodspot_dialog.error' | translate }} </span>
				</div>
			}
		</div>

		<div></div>
	</div>
</div>
